<script>
import { mapMutations, mapState } from 'vuex';

import PaymentTypeTab from './payment_type_tab.vue';

export default {
  components: {
    PaymentTypeTab
  },

  computed: {
    ...mapState([
      'paymentTypes',
      'selectedPaymentType'
    ])
  },

  methods: {
    ...mapMutations([
      'setSelectedPaymentType'
    ]),

    isChecked(type) {
      return this.selectedPaymentType === type;
    },

    updatePaymentType(type) {
      this.setSelectedPaymentType({ type });
    },
  }
};
</script>

<template>
  <div
    v-if="paymentTypes.length"
    class="mb-4"
  >
    <div class="c-payment-type-tabs">
      <div class="row g-4">
        <payment-type-tab
          v-for="paymentType in paymentTypes"
          :key="paymentType.type"
          :type="paymentType.type"
          :title="paymentType.title"
          :is-checked="isChecked(paymentType.type)"
          @update:payment-type="updatePaymentType"
        />
      </div>
    </div>
  </div>
</template>
